import React from 'react';
import {connect} from 'react-redux';

const Footer = (props) => {
        let {branding} = props;
        return (
          <React.Fragment>
          <footer>
          <p class="copyright">© { new Date().getFullYear() } <a href="https://www.thomasgold.com/" target="_blank">Thomas Gold Solutions</a>. All Rights Reserved.</p>
          </footer>
          </React.Fragment>
        )
}
const mapStateToProps = (state, ownProps) => {
  return {
      ...state.mainState,
      ...ownProps
  }
}

//   const mapDispatchToProps = { globalUpdateState }

export default connect(
  mapStateToProps,
  null
  // mapDispatchToProps
)(Footer)